<div class="dynamic-table-wrapper" [ngClass]="tableClass" [style.--row-height]="rowHeight + 'px'">
  <div class="table-scroll-container">
    <table mat-table [dataSource]="dataSource" matSort
           (matSortChange)="onSortChange($event)"
           class="dynamic-table">

      <!-- Dynamic columns -->
      <ng-container *ngFor="let col of getVisibleColumns()" [matColumnDef]="col.key">
        
        <!-- Header -->
        <th mat-header-cell *matHeaderCellDef
            [mat-sort-header]="col.sortable !== false && sortable ? col.key : ''"
            [disabled]="col.sortable === false || !sortable"
            [ngClass]="getAlignment(col)"
            [class.non-sortable]="col.sortable === false || !sortable"
            [style.width]="col.width || null"
            [style.minWidth]="col.width || null"
            [style.maxWidth]="col.width || null">
          {{ col.label }}
        </th>

        <!-- Cell -->
        <td mat-cell *matCellDef="let row"
            [ngClass]="getAlignment(col)"
            [class.non-sortable]="col.sortable === false || !sortable"
            [style.width]="col.width || null"
            [style.minWidth]="col.width || null"
            [style.maxWidth]="col.width || null"
            [class.clickable-cell]="clickableRows"
            (click)="onRowClick(row)">
          
          <!-- Custom template -->
          <ng-container *ngIf="cellTemplates[col.key]; else defaultCell">
            <ng-container *ngTemplateOutlet="cellTemplates[col.key]; context: { $implicit: row, column: col }">
            </ng-container>
          </ng-container>

          <!-- Default formatted cell -->
          <ng-template #defaultCell>
            <span *ngIf="col.type === 'currency'" class="currency-value">
              {{ formatCell(row, col) }}
            </span>
            <span *ngIf="col.type !== 'currency'">
              {{ formatCell(row, col) }}
            </span>
          </ng-template>
        </td>
      </ng-container>

      <!-- Header row -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

      <!-- Data rows -->
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
          [class.row-clickable]="clickableRows"
          [class.row-selected]="isSelected(row)">
      </tr>

      <!-- No data row -->
      <tr class="mat-row no-data-row" *matNoDataRow>
        <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
          No data available
        </td>
      </tr>
    </table>
  </div>

  <!-- Paginator -->
  <mat-paginator *ngIf="showPaginator"
    [pageSize]="paginatorPageSize"
    [pageSizeOptions]="paginatorPageSizeOptions"
    [length]="pagination ? paginatorLength : undefined"
    [pageIndex]="pagination ? paginatorPageIndex : undefined"
    [selectConfig]="paginatorSelectConfig"
    (page)="onPageChange($event)"
    aria-label="Select page">
  </mat-paginator>
</div>
